import React from 'react'
import { Label } from 'reactstrap'
import { Button, Input } from 'antd'
import './StepTwoPage.scss'
import { ArrowRightOutlined } from '@ant-design/icons'

const StepTwoPage = ({ next }) => {
    const { TextArea } = Input;
    return (
        <div className='step2-section'>
            <h1>What is <strong>your idea?</strong></h1>
            <form>
                <div className="form-field">
                    <Label>Startup name</Label>
                    <Input className="text-field-input"
                        placeholder="XYZ  "
                        name="startup-name"
                        type="text" />
                </div>
                <div className="form-field">
                    <Label>What are you building?</Label>
                    <TextArea rows={4} className="textarea-field-input"
                        placeholder="XYZ is a platform designed to simplify the fundraising process for non-profits.  "
                        name="what-building"
                        type="textarea" />
                </div>
                <div className="form-field">
                    <Label>Who is it for?</Label>
                    <Input className="text-field-input"
                        placeholder="Small, US-Based Non-Profits  "
                        name="who-for"
                        type="text" />
                </div>
                <div className="form-field">
                    <Label>Why does it matter?</Label>
                    <TextArea rows={4} className="textarea-field-input"
                        placeholder="Access to funding is one of the biggest hurdles faced by organizations, especially smaller ones.  "
                        name="why-matters"
                        type="textarea" />
                </div>
                <Button
                    // loading={authLoading}
                    // disabled={!isEnabled}
                    onClick={next}
                    className="continue-button"
                >
                    Continue <ArrowRightOutlined />
                </Button>
            </form>
        </div>
    )
}

export default StepTwoPage